import React from 'react';
import { Image } from '../Elements';
import './viewer.css';

const ImageViewer = ({ file, style }: { file: string; style?: object }) => {
  return <Image src={file} className="showImage test" style={style} />;
};

export default ImageViewer;
